import { useState } from 'react'
import styles from './TimezonePrompt.module.css'

export default function TimezonePrompt({ detectedTimezone, currentTimezone, onUpdate, onDismiss }) {
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdate = async () => {
    setIsLoading(true)
    try {
      await onUpdate()
    } catch (error) {
      console.error('Failed to update timezone:', error)
    } finally {
      setIsLoading(false)
    }
  }

  // Format timezone for display (e.g., "America/New_York" -> "America/New York")
  const formatTimezone = (tz) => {
    if (!tz) return 'Unknown'
    return tz.replace(/_/g, ' ')
  }

  return (
    <div className={styles.promptOverlay}>
      <div className={styles.promptCard}>
        <div className={styles.promptHeader}>
          <span className={styles.promptIcon}>🌍</span>
          <h3>Confirm Your Timezone</h3>
        </div>

        <div className={styles.promptBody}>
          <p>We detected your timezone as:</p>
          <p className={styles.detectedTimezone}>{formatTimezone(detectedTimezone)}</p>

          {currentTimezone && currentTimezone !== detectedTimezone && (
            <p className={styles.currentTimezone}>
              Current setting: {formatTimezone(currentTimezone)}
            </p>
          )}

          <p className={styles.description}>
            This helps us accurately track your work hours and split worklogs across midnight.
          </p>
        </div>

        <div className={styles.promptActions}>
          <button
            className={styles.dismissButton}
            onClick={onDismiss}
            disabled={isLoading}
          >
            Not now
          </button>
          <button
            className={styles.updateButton}
            onClick={handleUpdate}
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Confirm Timezone'}
          </button>
        </div>
      </div>
    </div>
  )
}
